var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, defineMessages } from 'react-intl';
var messages = defineMessages({
    termsAndConditions: {
        id: 'sidebar.information.termsAndConditions',
        defaultMessage: 'Правила'
    },
    responsibleGaming: {
        id: 'content.regulations.responsibleGaming',
        defaultMessage: 'Ответственная игра'
    },
    help: {
        id: 'content.regulations.help',
        defaultMessage: 'Помощь'
    },
    content_regulations_policy: {
        id: "content.regulations.policy",
        defaultMessage: "Политика конфиденциальности"
    },
    kycPolicy: {
        id: 'sidebar.information.kycPolicy',
        defaultMessage: 'Политика KYC'
    }
});
var Menu = /** @class */ (function (_super) {
    __extends(Menu, _super);
    function Menu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Menu.prototype.render = function () {
        var _a = this.props, props = _a === void 0 ? {} : _a;
        return (_jsx("div", __assign({ className: 'menu' }, { children: _jsxs("ul", { children: [_jsx("li", __assign({ className: props.location.pathname === '/terms_and_conditions' ? 'active' : '' }, { children: _jsx(FormattedMessage, __assign({}, messages.termsAndConditions, { children: function (message) { return _jsx(Link, __assign({ to: '/terms_and_conditions' }, { children: message })); } })) })), _jsx("li", __assign({ className: props.location.pathname === '/help' ? 'active' : '' }, { children: _jsx(FormattedMessage, __assign({}, messages.help, { children: function (message) { return _jsx(Link, __assign({ to: '/help' }, { children: message })); } })) })), _jsx("li", __assign({ className: props.location.pathname === '/privacy_policy' ? 'active' : '' }, { children: _jsx(FormattedMessage, __assign({}, messages.content_regulations_policy, { children: function (message) { return _jsx(Link, __assign({ to: '/privacy_policy' }, { children: message })); } })) })), _jsx("li", __assign({ className: props.location.pathname === '/kyc_policy' ? 'active' : '' }, { children: _jsx(FormattedMessage, __assign({}, messages.kycPolicy, { children: function (message) { return _jsx(Link, __assign({ to: '/kyc_policy' }, { children: message })); } })) }))] }) })));
    };
    return Menu;
}(React.Component));
;
export default withRouter(Menu);



// WEBPACK FOOTER //
// ./src/components/info/termsAndConditions/shared/Menu.jsx